"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _buttonControl = _interopRequireDefault(require("../button-control"));

var BadgeActions = function BadgeActions(_ref) {
  var id = _ref.id,
      title = _ref.title,
      onDelete = _ref.onDelete;
  return (0, _preact.h)("div", {
    style: {
      whiteSpace: "nowrap"
    }
  }, (0, _preact.h)("a", {
    href: (0, _absoluteUrlRuntime.resolveUrl)("/settings/badge/edit/".concat(id))
  }, (0, _preact.h)(_buttonControl.default, {
    title: "Edit",
    newStyle: true
  })), (0, _preact.h)(_buttonControl.default, {
    title: "Delete",
    newStyle: true,
    variant: "warning",
    onClick: function onClick() {
      return onDelete(id, title);
    }
  }));
};

var _default = BadgeActions;
exports.default = _default;